// extracted by mini-css-extract-plugin
export var wordContainer = "_q1-0";